var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('custom-select',{attrs:{"label":"Tipo de documento","value":_vm.value,"items":_vm.tiposDocumento},on:{"input":_vm.onChange,"click":function($event){return _vm.$emit('click')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }